import {
  Box,
  Divider,
  IconButton,
  Stack,
  SwipeableDrawer,
  Typography,
} from "@mui/material";
import { CustomAvatar, CustomButton, SvgContainer } from "../../../components";
import i18n from "../../../i18n-config";
import { Close } from "@mui/icons-material";
import theme from "../../../theme/theme";
import { PHONE, PdfICON } from "../../../assets/icons";

interface Props {
  item: any;
  open: boolean;
  onClose(): void;
  isProvider: boolean;
  onEdit: (item: any) => void;
}

function CorbeilleDetail({ item, open, onClose }: Props) {
  const onOpen = () => {
    console.log('onOpen');
  };

  return (
    <div>
      <SwipeableDrawer
        anchor={"right"}
        open={open}
        onClose={onClose}
        variant="temporary"
        onOpen={onOpen}
      >
        <Box
          sx={{
            width: {
              xl: "45vw",
              lg: "50vw",
            },
            backgroundColor: "#F7F7F7",
            height: "100%",
          }}
        >
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            sx={{ backgroundColor: theme.colors.primary }}
            p={3}
          >
            <Stack direction={"row"} spacing={2}>
              <Typography fontWeight={400} color={"white"} fontSize={20}>
                ID:
              </Typography>
              <Typography color={"white"} fontWeight={600} fontSize={20}>
                KHFKSDFSKFHKS
              </Typography>
            </Stack>
            <IconButton
              onClick={onClose}
              sx={{
                "&:hover": { backgroundColor: "transparent" },
                border: "1px solid #F9F9F9",
                height: 32,
                width: 32,
                p: 2,
              }}
            >
              <Close fontSize="medium" htmlColor={"#F9F9F9"} />
            </IconButton>
          </Stack>

          <Box sx={{ backgroundColor: "#fff", height: "100%", p: 3 }}>
            <Stack direction={"row"}>
              <CustomAvatar
                url={item?.image}
                avatarStyle={{
                  width: 75,
                  height: 75,
                  backgroundColor: "#EAE6EE",
                  color: theme.colors.primary,
                  borderRadius: 10,
                }}
              />
              <Box ml={3}>
                <Typography fontSize={18} fontWeight={600} mb={1}>{"Oufad Ndezi"}</Typography>
                <Stack direction={"row"} spacing={1}>
                  <SvgContainer svg={PHONE} color={"#9BA69C"} width={18} />
                  <Typography>{"699 99 99 99"}</Typography>
                </Stack>
              </Box>
            </Stack>
            <Divider sx={{ my: 3 }} />

            <Typography color={"#9BA69C"} fontWeight={600} mb={1}>
              Description
            </Typography>
            <Typography>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris.
            </Typography>
            <Typography color={"#9BA69C"} fontWeight={600} mb={1} mt={2}>
              Document
            </Typography>

            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              sx={{
                backgroundColor: "#E0F2DB",
                borderRadius: 1,
                height: 60,
                mb: 2,
                p: 4,
              }}
            >
              <Typography>CNI_Scan 1254025575.pdf</Typography>
              <PdfICON />
            </Stack>

            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              sx={{
                backgroundColor: "#E0F2DB",
                borderRadius: 1,
                height: 60,
                mb: 2,
                p: 4,
              }}
            >
              <Typography>CNI_Scan 1254025575.pdf</Typography>
              <PdfICON />
            </Stack>

            <CustomButton
              title={i18n.t("valider")}
              rootStyle={{
                backgroundColor: theme.colors.primary,
                height: 52,
                width: "100%",
                marginTop: 6
              }}
            />
            <Stack
              direction="row"
              justifyContent={"space-between"}
              spacing={4}
              mt={4}
            >
              <CustomButton
                title={i18n.t("liberer_tache")}
                rootStyle={{
                  backgroundColor: theme.colors.orange,
                  height: 52,
                  width: "100%",
                }}
              />
              <CustomButton
                title={i18n.t("refuser_tache")}
                rootStyle={{
                  backgroundColor: "#FFE5E5",
                  height: 52,
                  width: "100%",
                }}
                titleStyle={{ color: "#EF2E2E" }}
              />
            </Stack>
          </Box>
        </Box>
      </SwipeableDrawer>
    </div>
  );
}

export default CorbeilleDetail;
